<script setup lang="ts">
import type { TeaserParagraph } from '../../utils/paragraph-schema/paragraphs'

defineProps<{
  seriesMaster: TeaserParagraph['teaser']
}>()
</script>

<template v-if="seriesMaster?.titleLong || seriesMaster?.titleShort || seriesMaster?.titleMedium">
  <div class="bx-content bx-series bx-typo--series">
    <span class="bx-series__name">Aus der Serie: {{ seriesMaster.titleLong }}</span>
  </div>
</template>
